Popup = {
    isFixed: true,
    removeAfterHide: false,
    showAfterLoad: true,
    useCookie:false,
    el: {},

    init: function() {
        Popup.el = $('[component="popup"]');

        if(!Popup.el.length) return;

        $('.popup .close').click(function(event) {
            Popup.hide();
        });

        this.Agreement.init();

        // $(document).on('click', function(e) {
        //     if (e.target != Popup.el.get(0) && !Popup.el.find(e.target).length) {
        //         Popup.hide();
        //         $(this).off(e);
        //     }
        // });


        if(this.showAfterLoad){
            setTimeout(function() {
                Popup.afterPageLoaded();
            }, 200);
        }

        $('.popup').find('a').on('click', function(event) {
            Popup.setCookie();
        });

        this.injectSVG(Popup.el.find('.bottle'));

    },

    injectSVG: function(SVG){

        var injectorOptions = {
          evalScripts: 'once',
        };

        SVGInjector(SVG, injectorOptions, function (totalSVGsInjected) {
          Popup.animate(SVG);
        });
    },

    afterPageLoaded: function(){
        // console.log(Popup.getCookie() && $('.popup .locator .item').length != 0)
        if (Popup.getCookie()){
            Popup.show();
        } else {
            App.show();
        }
    },

    show: function() {


        Popup.el.addClass('visible').removeClass('hidden');

         setTimeout(function() {
            Popup.el.removeAttr('before-show').attr('ready', '');
        }, 10)

        
        if(this.isFixed)
            Popup.el.addClass('fixed');

        // Popup.el.find('.inner').addClass('show').removeClass('hide');
        Popup.el.find('.bg').addClass('show').removeClass('hide');
        Popup.el.find('.inner').addClass('show').removeClass('hide');
        
        $('.page-content').css('overflow-y', 'hidden');

        this.animate();
    },

    hide: function() {
        Popup.el.find('.inner').addClass('hide');
        Popup.el.find('.bg').addClass('hide');
        Popup.el.find('.bg').on('oanimationend animationend webkitAnimationEnd oAnimationEnd oAnimationEnd ', function() {
            if(Popup.removeAfterHide){
                Popup.el.remove();
            }
            Popup.el.addClass('hidden');
        });

        // setTimeout(function(){
        //     Popup.el.addClass('hidden');
        // },500)

        if(this.useCookie)
            Popup.setCookie();

        $('.page-content').css('overflow-y', 'auto');
        App.show();
    },

    animate: function(){
        var bottle = Popup.el.find('.bottle');
        var bottleright = $('#bottleright');
        var bottleleft = $('#bottleleft');
        var bottletop = $('#bottletop');
        var logo = $('#logo');
        var footer = $('#footer');
        var text1 = $('#text1');
        var text2 = $('#text2');
        var text3 = $('#text3');
        var icons = $('g[id^="icon"]');

        $(bottleright)
            .css({display:'block', strokeDashoffset:790, strokeDasharray:790})
            .velocity({strokeDashoffset:0}, {duration:1000});
        $(bottleleft)
            .css({display:'block', strokeDashoffset:1040, strokeDasharray:1040})
            .velocity({strokeDashoffset:0}, {duration:1000, delay:300});
        $(bottletop)
            .css({display:'block', strokeDashoffset:550, strokeDasharray:550})
            .velocity({strokeDashoffset:0}, {duration:500, delay:600});

        $(logo)
            .css({display:'block', opacity:0})
            .velocity({opacity:1}, {duration:200, delay:1100});

        $(icons).each(function(index, el) {
            $(this)
                .css({display:'block', opacity:0})
                .velocity({opacity:1}, {duration:200, delay:1100 + (100 * index)});
        });

         $(footer)
            .css({display:'block', opacity:0})
            .velocity({opacity:1}, {duration:200, delay:1500});

        setTimeout(function(){ $(text1).css({display:'block'}).addClass('show') }, 1800);
        setTimeout(function(){ $(text2).css({display:'block'}).addClass('show') }, 2000);
        setTimeout(function(){ $(text3).css({display:'block'}).addClass('show') }, 2300);

    },

    setCookie: function() {
        var date = new Date();
        var minutes = 360;
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        Cookies.set('closedPopup', 1, { expires: date });
    },

    getCookie: function() {
        if (Cookies.get('closedPopup'))
            return false;

        return true;
    },

    Agreement : {

        init: function(){
            $('.popup .button').click(function(event) {
                Popup.Agreement.check();
            });
        },

        check: function(){

            var check = $('.popup [type="checkbox"]');

            if (check.prop('checked') == true){
                Popup.hide();
            } else {
                Popup.Agreement.warn()
            }
            
        },

        warn: function(){
            var check = $('.popup .check');
            check.addClass('invalid');
            setTimeout(function(){
                check.removeClass('invalid');
            },2000)
        }
    }

    
}